<template>
  <div>
    <template v-for="(item, index) in formData" :key="index">
      <div
        class="header"
      >
        <div class="header_content">
          <!-- header -->
          <div class="content">
            <h4>{{ headerList[0].caseName }}</h4>
            <div class="title">
              {{
                `
            ${headerList[0].finalCustomer}/
            ${headerList[0].caseType}/
            ${headerList[0].time}
            `
              }}
            </div>
            <div class="title">
              当前案件累计工时：{{ headerList[0].countHour }}人月
              <van-button
                round
                size="small"
                style="
                  margin-left: 10px;
                  background: #a7ffd9;
                  border-color: #a7ffd9;
                  height: 24px;
                  width: 60px;
                "
                @click="onCaseInfo(headerList[index].id)"
              >
                查看
              </van-button>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          margin: 30px 10px 20px 10px;
          border-radius: 8px;
          overflow: hidden;
        "
      >
        <van-cell-group>
          <van-field
            label="登记日期:"
            input-align="right"
            readonly
            :model-value="
              time ||
              `${new Date().getFullYear()}-${
                new Date().getMonth() + 1
              }-${new Date().getDate()}`
            "
          />
          <van-field label="事项名称:"
            readonly
            is-link
            input-align="right" @click="onSelectPlanName" :model-value="item.planName" />
        </van-cell-group>
          <div class="activeBody">
                    <div class="nav">
                      <van-row>
                        <van-col span="3" v-if="userId == item.principal">完成</van-col>
                        <van-col :span="userId != item.principal ? 8 : 7">二级事项名</van-col>
                        <van-col :span="userId != item.principal ? 8 : 7"
                          style="text-align: center">计划工时(H)</van-col>
                        <van-col :span="userId != item.principal ? 8 : 7"
                          style="text-align: center"
                          >今日投入工时</van-col
                        >
                      </van-row>
                    </div>
                    <div>
                       <van-swipe-cell
                        v-for="(child, index) in item.childPlans"
                        :key="index">
                          <div
                        class="line"
                      >
                        <div class="inputCont">
                          <van-row class="rowInput">
                            <van-col span="3"
                              style="d"
                              v-if="userId == item.principal"
                              ><van-checkbox
                                :disabled="child.isDisabled || userId != item.principal"
                                v-model="child.check"
                                shape="square"
                            /></van-col>
                            <van-col :span="userId != item.principal ? 8 : 7">
                              {{ child.planName }}</van-col>
                            <van-col :span="userId != item.principal ? 8 : 7"
                              class="col" style="text-align: center">{{
                              child.planHours
                            }}</van-col>
                            <van-col :span="userId != item.principal ? 8 : 7"
                              class="col" style="text-align: center">
                              <input
                                type="number"
                                inputmode="decimal"
                                :min="0"
                                :max="24"
                                v-model="child.usesHours"
                              />
                            </van-col>
                          </van-row>
                        </div>
                        <!-- <div>
                          <van-field
                            :border="true"
                            label="原因"
                            v-model="child.reason"
                            placeholder="请输入原因"
                          />
                        </div> -->
                      </div>
                      <template #right>
                            <van-button
                              style="height:100%"
                              @click="onEdite(index)"
                              square type="danger" text="风险/原因" />
                          </template>
                    </van-swipe-cell>
                    </div>
          </div>
        <van-field
          rows="2"
          class="footInput"
          v-if="userId == item.principal"
          v-model="item.fasionDesc"
          autosize
          label="风险描述:"
          type="textarea"
          placeholder="请输入风险描述"
          show-word-limit
        />
      </div>
    </template>
    <div style="margin: 0px 20px 10px 20px">
      <van-button round size="normal" type="primary" @click="onPost" block
        >提交工时</van-button
      >
    </div>
    <!--  -->
    <van-action-sheet
      :show="state.palnListShow"
      :actions="state.palnList"
      :close-on-click-overlay="true"
      @select="onSelectPaln"
      @click-overlay="state.palnListShow = false"
    />
    <!-- popus -->
    <van-popup
      v-model:show="popupShow"
      closeable
      position="bottom"
    >
    <div class="popupContent">
        <div class="title">原因</div>
        <van-field
          v-model="pupupForm.reason"
          :formatter="formatter"
          placeholder="请输入原因"
        />
        <div class="title">风险</div>
        <van-field
          v-model="pupupForm.fasionDesc"
          :formatter="formatter"
          placeholder="请输入风险"
        />
      <div style="padding: 10px;">
          <van-button round @click="onPopupOK" block type="primary">确定</van-button>
        </div>
    </div>
    </van-popup>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getPlanDetail, postAdd, getUserSelectPlanList } from '@/http/caseForm';
import {
  CellGroup,
  Cell,
  Collapse,
  CollapseItem,
  Button,
  Checkbox,
  Field,
  Col,
  Row,
  Toast,
  ActionSheet,
  SwipeCell,
  Popup,
} from 'vant';

export default defineComponent({
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [ActionSheet.name]: ActionSheet,
    [SwipeCell.name]: SwipeCell,
    [Popup.name]: Popup,
  },
  setup(props) {
    const popupShow = ref(false);
    const pupupForm = reactive({
      reason: '',
      fasionDesc: '',
    });
    const pupupIndex = ref(0);
    const router = useRouter();
    const route = useRoute();
    const {
      projectId,
      time,
      type,
      status,
    } = route.query;
    const newType = ref(type);
    const userId = sessionStorage.getItem('userId');
    const details = ref({});
    const planData = ref({});
    const formData: any = ref([]);
    const headerList = ref([]);
    const selectIndex = ref(0);
    const state = reactive({
      palnListShow: false,
      palnList: [],
      selectPlanList: {},
    });
    const activeNames = ref(['0']);
    // 提交
    const onPost = () => {
      console.log(formData.value);
      let isLength = 0;
      const dataForm = JSON.parse(JSON.stringify(formData.value));
      const newArr: Array<any> = [];
      dataForm.forEach((item: any, index: number) => {
        const arr:[] = item.childPlans.filter((data: any) => (data.usesHours !== 0 && data.usesHours !== ''));
        console.log(arr);
        newArr.push(...item.childPlans);
        dataForm[index].childPlans = arr || [];
      });
      console.log(newArr);
      newArr.forEach((item:any) => {
        if (item.usesHours === 0 || item.usesHours === '') {
          isLength += 1;
        }
      });
      console.log(dataForm);
      if (isLength === newArr.length) {
        Toast('至少填写一个');
        return;
      }
      if (status === '1') {
        Toast('该项目已中断无法提交');
        return;
      }
      postAdd(dataForm).then((res) => {
        Toast('提交成功');
        setTimeout(() => {
          router.push({ path: '/' });
        }, 500);
      });
      console.log(formData.value);
    };
    const forData = (list: any) => {
      const data = list.map((item: any) => ({
        ...item,
        isDisabled: item.check,
        usesHours: item.usesHours || 0,
      }));
      return data;
    };
    const onSelectPlanName = () => {
      getUserSelectPlanList({ projectId: formData.value[0].pmId }).then((dataList: any) => {
        const list = dataList.result.map((item: any) => ({
          name: item.planName,
          id: item.id,
        }));
        state.palnListShow = true;
        state.palnList = list;
      });
    };
    // 获取当前
    const getData = (dataId: any) => {
      getPlanDetail({
        ids: dataId,
        type: newType.value,
        month: time || `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`,
      }).then((res: any) => {
        console.log(res);
        const { result } = res;
        headerList.value = result.map((item: any) => item.project);
        result.forEach((item: any, index: number) => {
          formData.value.push({
            id: item.plan.id,
            fasionDesc: item.plan.fasionDesc,
            childPlans: forData(item.plan.childPlans),
            month: time,
            principal: item.plan.principal,
            planName: item.plan.planName,
            pmId: item.project.id,
            pmName: item.project.caseName,
          });
        });
        // const {
        //   result: { project, plan },
        // } = res;
        // const data = plan.childPlans.map((item: any) => ({
        //   reason: item.reason || '',
        //   usesHours: item.usesHours || '',
        //   id: item.id,
        //   check: item.check || '',
        //   isDisabled: item.check,
        // }));
        // formData.value.childPlans = data;
        // formData.value.fasionDesc = plan.fasionDesc;
        // details.value = project;
        // planData.value = plan;
        // getUserSelectPlanList({ projectId: project.id }).then(
        //   (dataList: any) => {
        //     const list = dataList.result.map((item: any) => ({
        //       name: item.planName,
        //       id: item.id,
        //     }));
        //     state.palnList = list;
        //   },
        // );
      });
    };
    const tabSelectIndex = () => {
      selectIndex.value += 1;
      if (selectIndex.value === headerList.value.length) {
        selectIndex.value = 0;
      }
    };
    const onSelectPaln = (item: any) => {
      state.selectPlanList = item;
      state.palnListShow = false;
      formData.value = [];
      newType.value = '1';
      getData(item.id);
    };
    const onCaseInfo = (id: any) => {
      router.push({
        path: '/caseInfo',
        query: { projectid: id },
      });
    };
    // 添加风险
    const onEdite = (index: number) => {
      pupupIndex.value = index;
      popupShow.value = true;
      pupupForm.reason = formData.value[0].childPlans[pupupIndex.value].reason;
      pupupForm.fasionDesc = formData.value[0].childPlans[pupupIndex.value].fasionDesc;
    };
    // 提交风险
    const onPopupOK = () => {
      formData.value[0].childPlans[pupupIndex.value].reason = pupupForm.reason;
      formData.value[0].childPlans[pupupIndex.value].fasionDesc = pupupForm.fasionDesc;
      console.log(formData.value);
      popupShow.value = false;
    };
    getData(projectId);
    return {
      details,
      planData,
      activeNames,
      formData,
      onPost,
      time,
      state,
      onSelectPaln,
      onCaseInfo,
      headerList,
      selectIndex,
      tabSelectIndex,
      userId,
      popupShow,
      onEdite,
      pupupForm,
      onPopupOK,
      onSelectPlanName,
    };
  },
});
</script>

<style lang="scss" scoped>
/deep/ .van-cell {
  padding: 18px 16px;
  .van-cell__title {
    font-size: 16px;
    font-weight: bold;
  }
}
.header {
  min-height: 130px;
  position: relative;
  .header_content {
    background: #5374e8;
    min-height: 130px;
    position: relative;
    .content {
      padding: 10px 0;
      margin: auto;
      left: 0;
      right: 0;
      top: 30px;
      h4 {
        width: 320px;
        margin: auto;
        color: #fff;
      }
      .title {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #fff;
        width: 320px;
        margin: 10px auto;
      }
    }
  }
}
/deep/ .rowInput {
  .col {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .van-col {
    display: flex;
    align-items: center;
  }
}
.activeBody {
  background: #fff;
  font-size: 14px;
  padding: 14px 0;
  color: #757575;
  padding-top: 0;
  .nav {
    font-size: 14px;
    color: #b6b6b6;
    margin-bottom: 0px;
    background: #D7F3E7;
    color: #333;
    padding: 10px 16px;
  }
  .line {
    border-bottom: 1px solid #ebedf0;
  }
  .inputCont {
    padding: 20px 16px 20px 16px;
    input {
      width: 60px;
      height: 30px;
      border: 1px solid #ddd;
      padding-left: 10px;
    }
  }
}
.popupContent {
  margin-top: 40px;
  .title {
    font-size: 14px;
    font-weight: bold;
    padding-left: 16px;
    margin-top: 10px;
  }
}
/deep/ .footInput {
  display: block;
  .van-cell__title {
    margin-bottom: 10px;
  }
}
</style>
